import { render, staticRenderFns } from "./FloorViewer.vue?vue&type=template&id=27c2350b&"
import script from "./FloorViewer.vue?vue&type=script&lang=js&"
export * from "./FloorViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports